import { getEnvVar } from '../utils/getEnvVar'
import { FeatureNames, isFeatureAvailable } from '../utils/features'

// context
export const GET_CONTEXT = `${getEnvVar('REACT_APP_API_GATEWAY')}/up-gateway/v2/context`
export const SEND_LANG = `${getEnvVar('REACT_APP_API_GATEWAY')}${isFeatureAvailable(FeatureNames.laborSSO) ? '/up-authentication/v4/session/locale' : '/session/locale'}`
// auth
export const INIT_SSO = `${getEnvVar('REACT_APP_API_GATEWAY')}/up-authentication/v4/oauth/init`
